import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import "./filters";

import VueLazyload from "vue-lazyload";
import VueTheMask from "vue-the-mask";
import VeeValidate from "vee-validate";
import VueI18n from "vue-i18n";
import Meta from "vue-meta";
import VueSocialSharing from "vue-social-sharing";

import languages from "./languages/lang";

import bugsnag from "bugsnag-js";
import bugsnagVue from "bugsnag-vue";

Vue.use(VueLazyload);
Vue.use(VueTheMask);
Vue.use(VueI18n);
Vue.use(Meta);
Vue.use(VueSocialSharing);

Vue.config.productionTip = false;

const bugsnagClient = bugsnag("7669486d95f2f10f3ce4db7e97d79b61");
bugsnagClient.use(bugsnagVue(Vue));

const i18n = new VueI18n({
  locale: (navigator.language || navigator.userLanguage).replace("-", "_"),
  messages: languages
});

Vue.use(VeeValidate, {
  i18nRootKey: "validations",
  i18n,
  events: "blur"
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
